export default __webpack_public_path__ + "static/media/404.e6e698f1.png";